import Permissions, { type AugmentedPermissionName } from './Permissions'

const defaultPermissions: readonly AugmentedPermissionName[] = ['microphone']

const permissions = new Permissions(defaultPermissions)

export default permissions
